import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/* Layout */
import Layout from '../views/Layout/index'
import Layout1 from '../views/Layout/index1'

export const constantRouterMap = [
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '*', // 页面不存在的情况下会跳到404页面
    redirect: '/404',
    name: 'notFound',
    hidden: true
  },
  {
    path: '/',
    component: Layout1,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  },
  {
    path: '',
    component: Layout,
    children: [{
      path: 'abort',
      name: 'abort',
      component: () => import('@/views/abort/index'),
      meta: { title: '关于长城', icon: 'abort' }
    }, {
      path: 'services',
      name: 'services',
      component: () => import('@/views/services/index'),
      meta: { title: '产品服务', icon: 'services' }
    }, {
      path: 'services/round',
      name: 'round',
      component: () => import('@/views/services/round'),
      meta: { title: '圆线产品', icon: 'round' }
    }, {
      path: 'services/flat',
      name: 'flat',
      component: () => import('@/views/services/flat'),
      meta: { title: '扁线产品', icon: 'flat' }
    }, {
      path: 'power',
      name: 'power',
      component: () => import('@/views/power/index'),
      meta: { title: '长城力量', icon: 'power' }
    }, {
      path: 'news',
      name: 'news',
      component: () => import('@/views/news/index'),
      meta: { title: '新闻资讯', icon: 'news' }
    }, {
      path: 'news/detail',
      name: 'detail',
      component: () => import('@/views/news/detail'),
      meta: { title: '新闻资讯详情', icon: 'detail' }
    }, {
      path: 'contact',
      name: 'contact',
      component: () => import('@/views/contact/index'),
      meta: { title: '联系我们', icon: 'contact' }
    }, {
      path: 'contact/recruit',
      name: 'recruit',
      component: () => import('@/views/contact/recruit'),
      meta: { title: '联系我们详情', icon: 'recruit' }
    }]
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js